module.exports = __webpack_public_path__ + "img/plan_1.0677c02c.jpg";